"use strict";const e=require("react").lazy((()=>Promise.resolve().then((function(){return require("./index-cjs-DI0s90rZ.js")}))));exports.DrawerCartV3=e;